import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import CustomScrollbars from 'util/CustomScrollbars';

class SidenavContent extends Component {
    componentDidMount() {
        const { history } = this.props;
        const that = this;
        const pathname = `#${history.location.pathname}`; // get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function(event) {
                event.stopPropagation();
            };
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function(event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open');
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            };
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {}
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function(fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {}

        return null;
    }

    render() {
        return (
            <CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
                <ul className="nav-menu">
                    <li className="nav-header">Navigation</li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/reports">
                            <i className="zmdi zmdi-alert-triangle zmdi-hc-fw" />
                            <span className="nav-text">Meldungen</span>
                        </NavLink>
                        <NavLink to="/app/archive">
                            <i className="zmdi zmdi-archive zmdi-hc-fw" />
                            <span className="nav-text">Archiv</span>
                        </NavLink>
                        {this.props.userRole === 1 && (
                            <NavLink to="/app/settings">
                                <i className="zmdi zmdi-settings zmdi-hc-fw" />
                                <span className="nav-text">Einstellungen</span>
                            </NavLink>
                        )}
                    </li>
                    <li className="nav-header">Kontakt</li>
                    <li className="pl-4">
                        <i className="zmdi zmdi-phone zmdi-hc-fw" /> Hotline:
                        <div className="contact-body">
                            <div>0531 224 359 74</div>
                        </div>
                    </li>
                    <li className="pl-4">
                        <i className="zmdi zmdi-email zmdi-hc-fw" /> E-Mail:
                        <div className="contact-body">
                            <div>t.hickisch@leanact.de</div>
                        </div>
                    </li>
                </ul>
            </CustomScrollbars>
        );
    }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js